import Header from "../components/Header";
import Footer from "../components/Footer";
import "./MyFleet.css";
import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  Button,
  Icon,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  Box,
  MenuItem,
  Select,
  InputLabel,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";

import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { useDemoData } from "@mui/x-data-grid-generator";

const MyFleet = () => {
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
    window.scrollTo(0,0)
  }, []);
    

  async function getData() {
    await fetch("https://dummyjson.com/users")
      .then((response) => response.json())
      .then((json) => {
        console.log(json);
        setData(json.users);
      });
  }
  // console.log(data)

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  const LeadsColumn = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
    },
    {
      field: "image",
      headerName: "Image",
      width: 120,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div style={{ paddingLeft: 10 }}>
            <img
              src={params.row.image}
              style={{
                borderRadius: 50,
                height: 35,
                border: "1px solid #dee2e6",
              }}
            />
          </div>
        );
      },
    },

    {
      field: "username",
      headerName: "Username",
      width: 150,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <p style={{ marginTop: 10 }}>
            {params.row.username.charAt(0).toUpperCase() +
              params.row.username.slice(1).toLowerCase()}
          </p>
        );
      },
    },

    {
      field: "firstName",
      headerName: "Full Name",
      width: 150,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <p style={{ marginTop: 10 }}>
            {params.row.firstName.charAt(0).toUpperCase() +
              params.row.firstName.slice(1).toLowerCase()}{" "}
            {params.row.lastName.charAt(0).toUpperCase() +
              params.row.lastName.slice(1).toLowerCase()}
          </p>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      minWidth: 150,
    },

    {
      field: "phone",
      headerName: "Phone",
      width: 150,
      // renderCell: (params) => {
      //   return <p>{params.row.phone}</p>;
      // },
    },
    {
      field: "ssn",
      headerName: "Amount",
      width: 150,
      renderCell: (params) => {
        return (
          <p style={{ paddingLeft: 10 }}>{params.row.ssn.split("-")[0]}$</p>
        );
      },
    },
    {
      field: "birthDate",
      headerName: "Created At",
      width: 150,
      minWidth: 150,
      // renderCell: (params) => {
      //   return <p>{params.row.createdAt.split("T")[0]}</p>;
      // },
    },
  ];

  return (
    <div>
      <Header />
      {/* 
      <br />
      <br />
      <h1
        data-aos="zoom-in"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        style={{ textAlign: "center", fontFamily: "Ubuntu" }}
        id="contact-us-id-hash"
      >
        My Fleet
      </h1>
      <br /> */}

      <div className="">
        <iframe
          width="100%"
          height="400"
          className=""
          src="https://www.google.com/maps/d/embed?mid=1XQbORXtRD7PdESsxydLYbapDNMyV_6c&ehbc=2E312F"
        />
      </div>

      <div style={{ margin: "50px 30px" }}>
        <div style={{ height: 527, width: "100%" }}>
          <DataGrid
            className="datagrid"
            // rows={rows}
            rows={data}
            columns={LeadsColumn}
            pageSize={8}
            rowsPerPageOptions={[8]}
            checkboxSelection
            getRowId={(row) => row.id}
            // components={{
            //   Toolbar: CustomToolbar,
            // }}
          />
        </div>
      </div>

      <div style={{ height: 100, width: "100%" }} />

      {/*  */}
      <Footer />
    </div>
  );
};

export default MyFleet;
